import React, { Component } from 'react';
import { DFPSlotsProvider, AdSlot, DFPManager } from 'react-dfp';
import { mapping } from '../../utilities'

const BannerRectangleLarge = ({ osCode, agency }) => {

  const dfpData = osCode
  ? osCode
  : "ALL";
  var tag = mapping[dfpData];
  
  if(agency){
    localStorage.setItem('dfpTag','agency'),
    localStorage.setItem('dfpValue','Y')
  }else{
    if(osCode){
      localStorage.setItem('dfpTag','os_code'),
      localStorage.setItem('dfpValue',tag)
    }else{
      localStorage.setItem('dfpTag','os_code'),
      localStorage.setItem('dfpValue','ALL')
    }
  }


  return (
  <div style={{ width: 728, height: 90, margin: 'auto' }}>
    <DFPSlotsProvider
      dfpNetworkId="73516391/homepage-bottom-leaderboard"
      sizeMapping={[
        { viewport: [0, 0], sizes: [728, 90] }]}

    >
    {agency ? 
      <AdSlot style={{ margin: '25px 0' }}
          sizes={[[728, 90]]}
          dfpNetworkId='73516391/homepage-bottom-leaderboard'
          targetingArguments={{ agency: "Y" }}
          adUnit='div-gpt-ad-1512999135502-0'
          shouldRefresh={() => true}
      />
    : (tag ?  
        <AdSlot style={{ margin: '25px 0' }}
          sizes={[[728, 90]]}
          dfpNetworkId='73516391/homepage-bottom-leaderboard'
          targetingArguments={{ os_dest: tag }}
          adUnit='div-gpt-ad-1512999135502-0'
          shouldRefresh={() => true}
        />
        :
        <AdSlot style={{ margin: '25px 0' }}
          sizes={[[728, 90]]}
          dfpNetworkId='73516391/homepage-bottom-leaderboard'
          adUnit='div-gpt-ad-1512999135502-0'
          shouldRefresh={() => true}
        />
      )
    }
    </DFPSlotsProvider>
  </div>
  )
};

export default BannerRectangleLarge


// WEBPACK FOOTER //
// ./src/components/Banner/BannerRectangleLarge.js